<template>
  <v-container class="grey lighten-5">
    <div v-if="selectedCourse===null">
      <v-row>
        <v-col cols="12" sm="8">
          <h2>Kurse</h2>
          <br/>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left">
                  Titel
                </th>
                <th class="text-left">
                  Online
                </th>
                <th class="text-left">
                  Status
                </th>
                <th class="text-left">
                  Beschreibung (Extrakt)
                </th>
                <th class="text-left">
                </th>
                <th class="text-center">
                </th>
              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="item in courses" :key="item.id"
              >
                <td><b>{{ item.title }}</b></td>
                <td><b>{{ item.online }}</b></td>
                <td><label v-if="item.applicantsWaiting" style="color: red">Unbestätigte
                  Bewerbungen</label></td>
                <td>{{ item.description }}</td>
                <td>
                  <v-btn text class="ma-2" color="info" @click.stop="openCourse(item)">Öffnen
                  </v-btn>
                </td>
                <td>
                  <v-btn class="ma-2" color="red" x-small fab outlined @click="deleteCourse(item)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>

        </v-col>
        <v-col cols="12" sm="4">
          <v-card style="padding: 16px">
            <h2>AGB</h2>
            <v-textarea v-model="agb" label="AGBs"/>
            <v-card-actions>

              <v-btn class="ma-1" color="info" :loading="loading"
                     :disabled="loading || agb === ''" @click="updateAgb">
                Speichern
                <template v-slot:loader>
            <span class="custom-loader">
              <v-icon light>mdi-cached</v-icon>
            </span>
                </template>
              </v-btn>
            </v-card-actions>
          </v-card>
          <v-card style="padding: 16px; margin-top: 24px">
            <h2>Präsenzkursverwaltung</h2>
            <br/>
            <h3>Erstellen</h3>
            <v-text-field v-model="title" label="Titel"/>
            <v-text-field v-model="location" label="Ort"/>
            <v-text-field v-model="price" label="Preis"/>
            <v-textarea v-model="description" label="Beschreibung"/>
            <v-checkbox v-model="canBorrowBooks" label="Bücherausleih"/>
            <v-checkbox v-model="lastAssessmentDateRequired" label="Letztes Prüfungsdatum angeben"/>
            <v-checkbox v-model="online" label="Online"/>

            <v-treeview
                item-key="key"
                v-model:selected="tag"
                :items="filterTree"
                selection-type="leaf"
                return-object
                selectable
            >
              <template v-slot:label="{item}">
                <div class="v-treeview-node__label">{{ item.name }} <label
                    @click.stop="copyClipBoard(item)"
                    style="color: cadetblue">Copy für csv</label>
                </div>
              </template>
            </v-treeview>

            <v-card-actions>

              <v-btn class="ma-1" color="info" :loading="loading"
                     :disabled="loading || title === '' || description === '' || tag.length !== 1"
                     @click="create">
                Kurs erstellen
                <template v-slot:loader>
            <span class="custom-loader">
              <v-icon light>mdi-cached</v-icon>
            </span>
                </template>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-snackbar :timeout="5000" :value="success" color="primary" left shaped top app>Gespeichert
      </v-snackbar>
      <v-snackbar :timeout="5000" :value="error" color="error" left shaped top>Fehler.</v-snackbar>
    </div>
    <div v-else>
      <v-btn class="ma-2" color="indigo" outlined small @click="selectedCourse = null">
        Zurück
      </v-btn>
      <SuperAdminCourseApplication :data="selectedCourse" @reload="loadData"/>
    </div>
  </v-container>

</template>

<script>

import SuperAdminLiveCourse from "@/components/sites/SuperAdminLiveCourse.vue";
import BuyCourse from "@/models/BuyCourse";
import SuperAdminCourseApplication from "@/components/sites/SuperAdminCourseApplication.vue";
import sharedFilterTree from "@/api/filtertree";

export default {
  name: "SuperAdminCourseApplications",
  components: {SuperAdminCourseApplication, SuperAdminLiveCourse},
  data: () => ({
    courses: [],
    course: null,
    loading: false,
    selectedCourse: null,
    success: false,
    error: false,
    title: "",
    agb: "",
    location: "",
    price: "",
    description: "",
    canBorrowBooks: "",
    lastAssessmentDateRequired: false,
    online: false,
    tag: [],
    filterTree: sharedFilterTree
  }),
  methods: {
    deleteCourse(item) {
      this.loading = true;
      this.$httpBuyCourseApi.delete(item.id, () => {
        this.loadData();
        this.loading = false;
        this.successText = "Erfolgreich gelöscht"
        this.success = true;
        this.loadData();
        setTimeout(() => {
          this.success = false;
        }, 3000);
      });
    },
    openCourse(item) {
      this.selectedCourse = item;
    },
    copyClipBoard(item) {
      const clipboardData =
          event.clipboardData ||
          window.clipboardData ||
          event.originalEvent?.clipboardData ||
          navigator.clipboard;

      clipboardData.writeText(item.key + "<>" + item.tags.join(","));
    },
    create() {
      this.loading = true;
      this.$httpBuyCourseApi.create(new BuyCourse({
        title: this.title,
        description: this.description,
        location: this.location,
        tagKey: this.tag[0].key,
        price: this.price,
        tags: this.tag[0].tags,
        canBorrowBooks: this.canBorrowBooks,
        lastAssessmentDateRequired: this.lastAssessmentDateRequired,
        online: this.online
      }), () => {
        this.loading = false;
        this.location = "";
        this.successText = "Erfolgreich Erstellt"
        this.success = true;
        this.name = "";
        this.tag = [];
        this.course = null;
        this.loadData();
        setTimeout(() => {
          this.success = false;
        }, 3000);
      });
    },

    updateAgb() {
      this.$httpBuyCourseApi.updateAgb(this.agb);
    },

    loadData() {
      this.$httpBuyCourseApi.getAll((result) => {
        this.courses = result;
        this.$httpBuyCourseApi.getAgb((agbResult) => {
          this.agb = agbResult;
        })
      });
    }
  },
  mounted() {
    this.loadData();
  }
}
</script>

<style scoped>

</style>
